<template>
  <div class="koc-event-sessions-column">
    <div
      v-if="title"
      :style="state.headerStyle"
      class="koc-event-sessions-column-header"
    >
      <h1
        class="koc-event-sessions-column-title"
        :class="dayColumns ? 'day-column-header' : ''"
        v-html="title"
      />
    </div>
    <div
      :class="columns <= 1 ? 'single-column' : 'wrap-row'"
      class="koc-event-sessions-column-sessions-wrapper"
    >
      <event-replay-sessions-item
        v-for="session in sessions"
        :key="session.id"
        :color="bgColor"
        :columns="columns"
        :session="session"
        :day-column-style="dayColumns"
        @play="playVideo"
      />
    </div>
  </div>
</template>

<script src="./event-replay-sessions-column.js"></script>
<style lang="scss" scoped src="./event-replay-sessions-column.scss"></style>
